// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"1f74c3f0","903":"21e95018","959":"61cab7d3"}[chunkId] + ".chunk.js";
};